var map = {
	"./ACDC.svg": "VFME",
	"./CO2.svg": "d0dh",
	"./D.svg": "HeH6",
	"./M.svg": "ZtGB",
	"./T.svg": "SVIf",
	"./Y.svg": "zi+e",
	"./add.svg": "4cSG",
	"./addPic.svg": "FTm9",
	"./alarm.svg": "YdUd",
	"./app-curve.svg": "Wu2A",
	"./app-display.svg": "0KR6",
	"./app-distr.svg": "hfIi",
	"./app-electricity.svg": "Wi3d",
	"./app-inspect.svg": "uARr",
	"./app-insurance.svg": "JDc9",
	"./app-ivScan.svg": "seIU",
	"./app-maintenance.svg": "Nenf",
	"./app-more.svg": "9rRM",
	"./app-networking.svg": "2wsP",
	"./app-report.svg": "5min",
	"./app-selfInspect.svg": "AJN6",
	"./app-sim.svg": "n5vR",
	"./app-virtualWeatherStation.svg": "P3bf",
	"./arrow-d.svg": "p06T",
	"./arrow-l.svg": "HOFY",
	"./arrow-r.svg": "toOo",
	"./arrow-u.svg": "5EjI",
	"./arrowDouble-d.svg": "kV/y",
	"./authorize.svg": "jKl9",
	"./back.svg": "JmN5",
	"./batchmenu.svg": "WqPv",
	"./battery-0.svg": "VN5f",
	"./battery-1.svg": "vOfO",
	"./battery-2.svg": "FmUx",
	"./battery-3.svg": "lxX+",
	"./battery-4.svg": "phDE",
	"./battery-5.svg": "BG/+",
	"./battery-unknow.svg": "tvrW",
	"./battery.svg": "q4P9",
	"./bell.svg": "FvmK",
	"./box-alarm.svg": "XHS/",
	"./box-apply.svg": "CV7W",
	"./box-workOrder.svg": "QXqc",
	"./caret-d.svg": "nuwo",
	"./cc.svg": "bCcC",
	"./cha.svg": "H4fz",
	"./chrome.svg": "bcEZ",
	"./clone.svg": "Y3To",
	"./close.svg": "usbd",
	"./coal.svg": "y1M8",
	"./comment.svg": "EqCG",
	"./communication-normal.svg": "EJzD",
	"./config.svg": "ZfcP",
	"./contactName.svg": "hXVo",
	"./ctrl.svg": "NCJS",
	"./danger.svg": "vyad",
	"./dangerAll.svg": "rs4T",
	"./date.svg": "iEN+",
	"./delete.svg": "ZEWN",
	"./deploy.svg": "UHu3",
	"./deviceData-E.svg": "YdCB",
	"./deviceData-P.svg": "tzqx",
	"./deviceData-capability.svg": "YsAg",
	"./deviceData-discreteRate.svg": "a8aX",
	"./deviceData-inverter.svg": "JyBt",
	"./dirArrow-l.svg": "Ptaq",
	"./dirArrow-r.svg": "axVX",
	"./display-CO2.svg": "XnpG",
	"./display-light.svg": "dqrn",
	"./display-plant-a.svg": "F4ss",
	"./display-plant-b.svg": "JDMw",
	"./display-plant.svg": "Mm4F",
	"./display-purse.svg": "hgr4",
	"./display-tree.svg": "RlaZ",
	"./display.svg": "6ZRZ",
	"./displayConfig-title.svg": "ygNt",
	"./download.svg": "UXgm",
	"./drag.svg": "n2V3",
	"./dv-API.svg": "NrJq",
	"./dv-DTU.svg": "SZjD",
	"./dv-EPM.svg": "IXNn",
	"./dv-airConditioning.svg": "fWSF",
	"./dv-battery.svg": "y5gH",
	"./dv-combinerBox.svg": "KQE8",
	"./dv-comp.svg": "euQT",
	"./dv-fan.svg": "gd0Y",
	"./dv-generator.svg": "340o",
	"./dv-hybridEnergyCabinet.svg": "UqHQ",
	"./dv-inverter.svg": "q/uf",
	"./dv-logger.svg": "rK07",
	"./dv-meter.svg": "yeUM",
	"./dv-microInverter.svg": "9PNy",
	"./dv-other.svg": "KtGE",
	"./dv-repeater.svg": "BhAU",
	"./dv-smartHome.svg": "n1Ex",
	"./dv-smartMeter.svg": "ujVB",
	"./dv-waterPump.svg": "vyu0",
	"./dv-waterQualityMonitoring.svg": "CMQq",
	"./dv-weatherStation.svg": "AcLm",
	"./eTower.svg": "qxXn",
	"./ebao.svg": "ouaD",
	"./edit-project.svg": "ZXGT",
	"./edit.svg": "KJUk",
	"./email.svg": "i1m2",
	"./etc-o.svg": "ou0O",
	"./examine.svg": "+HAN",
	"./export.svg": "uPuA",
	"./fileType-damage.svg": "Gri2",
	"./fileType-excel.svg": "h0oj",
	"./fileType-file.svg": "HwBL",
	"./fileType-pdf.svg": "28+Z",
	"./fileType-text.svg": "PY3c",
	"./fileType-word.svg": "nlge",
	"./filter.svg": "PTMJ",
	"./firefox.svg": "94o/",
	"./fold.svg": "UWrL",
	"./fullScreen.svg": "kVC+",
	"./group.svg": "8Vdd",
	"./help.svg": "/9hz",
	"./helpTip.svg": "XJgd",
	"./home.svg": "J8GQ",
	"./house-useElectricity.svg": "OSKN",
	"./house.svg": "LCIe",
	"./ico-1.svg": "txF0",
	"./ico-2.svg": "2///",
	"./import.svg": "aYs0",
	"./incFace.svg": "Sct3",
	"./info-admin.svg": "lIef",
	"./inspect-cover.svg": "oTFP",
	"./inspect-multiple.svg": "8e2+",
	"./inspect-single.svg": "eh8I",
	"./insurance.svg": "WHCm",
	"./label-icon.svg": "hMGy",
	"./landline.svg": "kiCS",
	"./link.svg": "s3+7",
	"./list.svg": "lFS3",
	"./load.svg": "83p3",
	"./location.svg": "C5qe",
	"./logout.svg": "QZ3o",
	"./logoutNav.svg": "91lv",
	"./map.svg": "IxiL",
	"./marker.svg": "LLbh",
	"./menu-1.svg": "fcpi",
	"./menu-10.svg": "JV+6",
	"./menu-11.svg": "27Ve",
	"./menu-12.svg": "qjFN",
	"./menu-13.svg": "+xok",
	"./menu-14.svg": "g5FX",
	"./menu-15.svg": "/ELe",
	"./menu-2.svg": "vgP0",
	"./menu-3.svg": "aKJR",
	"./menu-4.svg": "4DPq",
	"./menu-5.svg": "8u6G",
	"./menu-6.svg": "3tQT",
	"./menu-7.svg": "oXM3",
	"./menu-8.svg": "WxB6",
	"./menu-9.svg": "d3mQ",
	"./menu-data-on.svg": "2xhU",
	"./menu-inspect.svg": "2Idb",
	"./menu-layer.svg": "Fwgo",
	"./menu-tag.svg": "N8Tc",
	"./menu-user-option.svg": "YfD5",
	"./menu-user.svg": "DTTz",
	"./menu-users.svg": "JSBU",
	"./mode-card.svg": "DM7C",
	"./mode-list.svg": "AS0L",
	"./more.svg": "3/hf",
	"./new14.svg": "ACBV",
	"./new16.svg": "AN+C",
	"./new22.svg": "2Ibg",
	"./new23.svg": "7oOj",
	"./new25.svg": "gDiG",
	"./new26.svg": "EnjH",
	"./new32.svg": "pXV6",
	"./new33.svg": "f4V9",
	"./new4.svg": "yXMO",
	"./new5.svg": "LhBq",
	"./new66.svg": "nj9a",
	"./new7.svg": "yKm0",
	"./new72.svg": "USPB",
	"./new74.svg": "XAkS",
	"./new94.svg": "uMXc",
	"./new95.svg": "qICe",
	"./no.svg": "Eg9J",
	"./noAlarm.svg": "NsMW",
	"./noCommunication.svg": "65dF",
	"./noData.svg": "lLLd",
	"./noMessage.svg": "Ylw0",
	"./offline-all.svg": "MIQc",
	"./offline-part.svg": "o3eg",
	"./on.svg": "MFTv",
	"./outRelation.svg": "w3Rr",
	"./outRelations.svg": "mVBQ",
	"./outRole.svg": "jxzN",
	"./parentSystem.svg": "3V4J",
	"./persenSetting.svg": "FgUF",
	"./phone-model.svg": "UGdP",
	"./phone.svg": "RH/p",
	"./photo.svg": "5vuh",
	"./plant-wind-o.svg": "Orq2",
	"./plant-wind.svg": "SvB/",
	"./plant.svg": "UZK/",
	"./posArrow-up.svg": "gyH+",
	"./preview.svg": "Zwwz",
	"./productManage.svg": "z19k",
	"./providerIcon.svg": "2n8G",
	"./question.svg": "mqUg",
	"./reInspect.svg": "CDyZ",
	"./recycle.svg": "palW",
	"./reduce.svg": "bjWj",
	"./refresh.svg": "wK1c",
	"./relieve.svg": "aVl7",
	"./reload.svg": "hGTH",
	"./resend.svg": "DbRJ",
	"./resetPassword.svg": "aXOA",
	"./resetView.svg": "i4nH",
	"./resubmit.svg": "ibZP",
	"./revoke.svg": "7fc+",
	"./revoked.svg": "wcKm",
	"./satellite-off.svg": "mdtO",
	"./satellite-on.svg": "WOG5",
	"./satellite.svg": "C1H3",
	"./search.svg": "BzcE",
	"./service.svg": "xGWY",
	"./serviceprovider.svg": "mCAt",
	"./setting-mobile.svg": "9xLe",
	"./setting.svg": "JWg3",
	"./setup.svg": "pWza",
	"./shield-danger.svg": "S7i+",
	"./shield-save.svg": "IH71",
	"./shield-yes-o.svg": "1b4q",
	"./shield-yes.svg": "L2Nn",
	"./show.svg": "vsUp",
	"./site.svg": "8dZV",
	"./sizeCtrl.svg": "ribp",
	"./solarEnergy.svg": "DN5R",
	"./square-build.svg": "Aj0D",
	"./square-classification.svg": "PtaT",
	"./square-offline-all.svg": "vJGy",
	"./square-offline-part.svg": "rXqH",
	"./square-status-alarm.svg": "0uY7",
	"./star-off.svg": "mUd6",
	"./star-on.svg": "wOTZ",
	"./status-alarm.svg": "2PY7",
	"./status-danger.svg": "R6b8",
	"./status-success.svg": "82HO",
	"./status-waiting.svg": "c9Nk",
	"./status-warning.svg": "KvwK",
	"./stoptask.svg": "7RWK",
	"./sunrise.svg": "zOBz",
	"./sunset.svg": "E7B6",
	"./tag.svg": "j6Ty",
	"./temp.svg": "8bpX",
	"./template-hide.svg": "qfCp",
	"./template-show.svg": "aFZL",
	"./testDevice.svg": "S2f9",
	"./time-o.svg": "NEIh",
	"./time.svg": "vsvj",
	"./tipArrow.svg": "Jjaf",
	"./totalIncome.svg": "r/zG",
	"./transfer.svg": "KsWh",
	"./trash.svg": "Ubxc",
	"./tree.svg": "ArG6",
	"./unFullScreen.svg": "IlIn",
	"./unfold.svg": "vD+H",
	"./unknow.svg": "iAMO",
	"./unknowFile.svg": "ocqz",
	"./unlink.svg": "NPuX",
	"./unon.svg": "P/W0",
	"./up-mobile.svg": "DOHr",
	"./update.svg": "+hax",
	"./upgrade.svg": "hgk7",
	"./upload.svg": "ZMih",
	"./userFace.svg": "Scbf",
	"./wind.svg": "8gsG",
	"./windSpeed.svg": "ttwx",
	"./workOrder-admin.svg": "bKx1",
	"./workOrder-tpl-1.svg": "v3nt",
	"./workOrder-tpl-2.svg": "/zOP",
	"./working-index-deal.svg": "Lncu",
	"./working-index-join.svg": "iIVp",
	"./working-index-launch.svg": "iZf8",
	"./workorder-template-none.svg": "PXZR",
	"./yes.svg": "kWg0"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "VY/N";


//////////////////
// WEBPACK FOOTER
// ./src/icons/common nonrecursive \.svg$
// module id = VY/N
// module chunks = 6